const customer = {
    getAddressByZipcode: "user/find-cep",
    getUserExistence: "user/check",
    getUserData: "user/get-data",
    postLeadData: "marketing/lead/create"
}
const product = {
    getProductDataList: "gateway/product",
    getCouponDiscount: "payment/coupon-check"
}
const payment = {
    getPaymentDataList : "gateway/payment-methods"
}
const thankYou = {
    postFormData : "user/create-checkout"
}


export { customer, product, payment, thankYou };